import "core-js/modules/es.array.concat.js";
import { getProductPath } from './productTypes';
export var getProductReviewsPath = function getProductReviewsPath(product) {
  return "".concat(getProductPath(product), "/reviews");
};
export var getProductReviewPath = function getProductReviewPath(product, review) {
  var productPath = getProductPath(product);
  return "".concat(productPath, "/reviews/").concat(review.id);
};